export class M365UserSearchFilter {

    public constructor(init?: Partial<M365UserSearchFilter>) {
        Object.assign(this, init);
    }

    public searchTerm: string = null;
    public topCount = 10;
}
